function updateSkyscraperSkipping(value) {
  return {
    type: 'UPDATE_SKIP_SKY',
    data: value,
  };
}

export {updateSkyscraperSkipping};
